export default __webpack_public_path__ + "static/devops-casestudy-1-6b626c329000b353b4a7ca1a5777bd5f.png";